import React, { useState,useEffect,useReducer } from 'react';

import '../../Assets/css/custom.css';
import '../../Assets/css/w3-css.css';
import {Link} from 'react-router-dom';
import {Redirect} from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Navbar from 'react-bootstrap/Navbar';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Table from 'react-bootstrap/Table';
import Header from '../../Common/Header';
import Modal from 'react-bootstrap/Modal';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";   
import CommonAPI from '../../Common/CommonAPI';
import Switch from "react-switch";
import SuccessMSG from "../../Common/SuccessMsg"

function MaintainTransferRecipient (props){

    const [Password,setPassword] = useState();
    const [SelectFromAll,setSelectFromAll] =useState({});
    const [SelectFromAccount,setSelectFromAccount] = useState([]);
    const [ExistSelectAccountID,setExistSelectAccountID] = useState();
    const [ExistBeneRef,setExistBeneRef] = useState();
    const [ExistSelectToAmount,setExistSelectToAmount] = useState();
    const [ExistToBankId,setExistToBankId] = useState();
    const [ExistToBankBranchId,setExistToBankBranchId] = useState();
    const [ExistBeneName,setExistBeneName] = useState();
    const [ExistBankName,setExistBankName] = useState();
    const [ExistBranchName,setExistBranchName] = useState();
    const [ExistEmail,setExistEmail] = useState();
    const [ExistMobile,setExistMobile] = useState();
    const [ExistSelectToAccount,setExistSelectToAccount] = useState();
    const [CheckEdit,setCheckEdit] = useState(false);
    const [BankList,setBankList] = useState([]);
    const [SelectBankAll,setSelectBankAll] = useState({});
    const [NewSelectedBranchID,setNewSelectedBranchID]= useState();
    const [NewSelectedBranch,setNewSelectedBranch] =useState();
    const [SenkAccountValidate,setSenkAccountValidate] =useState();
    const [BranchList,setBranchList] =useState([]);

    const [SelectBranchAll,setSelectBranchAll] =useState({});
    const [NewBankId,setNewBankId] =useState();
    const [NewSelectBank,setNewSelectBank] =useState();
    const [, forceUpdate] = useReducer(x => x + 1, 0);
    const [ErrorMSG , setErrorMSG] = useState();
    const [RemoveRecipient , setRemoveRecipient] = useState(false);
    const [ExistTeleCode , setExistTeleCode] = useState();
    const [EditRecipient,setEditRecipient] = useState(false);


    const GetBankListAPI = () =>{
        CommonAPI.FetchBankList((results) =>{   
            if( results){                    
                setBankList(results);                              
            }
        });
      }

    const GetExistingPayeeAPI = () =>{
        CommonAPI.GetExistingPayee((results) =>{   
            if( results){                    
                setSelectFromAccount(results);
            }
        });
      }

    useEffect( () => {    
        GetExistingPayeeAPI();
        GetBankListAPI();
        },[])  ;


    const SelectRecipientList =(event) =>{
            var passValFrom = JSON.parse(event.target.value);
            setSelectFromAll(JSON.parse(event.target.value));
            setExistSelectAccountID( passValFrom.id);
            setExistSelectToAccount(passValFrom.beneAccountNo);
            setExistBeneRef(passValFrom.reference);
            setExistSelectToAmount (passValFrom.avialableBalance);            
            setExistBeneName(passValFrom.beneName);
            setExistToBankId(passValFrom.beneBankId);
            setExistToBankBranchId(passValFrom.beneBankBrId);
            setExistBankName(passValFrom.beneBankName);
            setExistBranchName(passValFrom.beneBrachName);
            setExistEmail(passValFrom.beneEmail);
            setExistMobile(passValFrom.benePhone);
         }

    const  handleEdit = (checked)=>{
        setCheckEdit(!CheckEdit);
    }

    const SelectBankList = (event) => {

        var passValFrom = JSON.parse(event.target.value);
        if(passValFrom.id===37){
            setNewSelectedBranchID("001")
            setNewSelectedBranch("Kandy")
            forceUpdate()
        }else{
             setSenkAccountValidate(false);
             setNewSelectedBranchID();
            };       
    
        setBranchList([]);
        setNewSelectedBranch("");
        
        setSelectBankAll(JSON.parse(event.target.value));
        setNewBankId(passValFrom.id);
        setNewSelectBank(passValFrom.name);
       
        if(passValFrom.id){
            CommonAPI.FetchBranchList({bid: passValFrom.id},(results) =>{   
                if( results){                    
                    setBranchList(results);                              
                }
            });      
          }
       }

       const  SelectedBranch = (event) => {
        //setBranchValid();
        var passValFrom = JSON.parse(event.target.value);  
          setSelectBranchAll(JSON.parse(event.target.value));  
          setNewSelectedBranch(passValFrom.name);         
          setNewSelectedBranchID(passValFrom.id);  
        }

        const RemoveCheckFirstPassword = () =>{
           
           CommonAPI.CheckPassword({password:Password},(results) =>{ 
            if(results.password==="true"&&ExistSelectToAccount){
                setErrorMSG();
                RemoveRecipientAPI();
            }else{
                setErrorMSG("Select a Recipient Or Enter Correct Password");
            }
           })
        }

        const RemoveRecipientAPI = () => {
            CommonAPI.RemoveRecipient({ExistSelectAccountID:ExistSelectAccountID},(results)=>{
                if(results.message=='Success'){
                    setRemoveRecipient(true);
                    GetExistingPayeeAPI();
                    setExistBeneName();
                    setExistSelectToAccount();
                    setExistBankName();
                    setExistBranchName();
                    setExistEmail();
                    setExistMobile();
                    setErrorMSG();
                    
                }else{
                    setErrorMSG("Recipient Remove Unsuccess");
                }
            })
        }

        const EditCheckFirstPassword = () =>{  
            if(!NewBankId) {
                setErrorMSG("Select a New Bank");
            }else if(!NewSelectedBranchID){
                setErrorMSG("Select a New Branch");
            }else{
            CommonAPI.CheckPassword({password:Password},(results) =>{ 
             if(results.password==="true"&&ExistSelectToAccount){
                 setErrorMSG();
                 EditRecipientAPI();
             }else{
                 setErrorMSG("Select a Recipient Or Enter Correct Password");
             }
            })
          }
        }

         const EditRecipientAPI = () => {
            CommonAPI.ConfirmEditBene({
                ExistSelectAccountID:ExistSelectAccountID,
                ExistBeneName:ExistBeneName,
                ExistSelectToAccount:ExistSelectToAccount,
                NewBankId:NewBankId,
                NewSelectBank:NewSelectBank,
                NewSelectedBranchID:NewSelectedBranchID,
                NewSelectedBranch:NewSelectedBranch,
                ExistMobile:ExistMobile,
                ExistEmail:ExistEmail,
                ExistTeleCode:ExistTeleCode,

            },(results)=>{
                if(results.message==="true"){
                    setEditRecipient(true);
                    GetExistingPayeeAPI();
                    setExistBeneName();
                    setExistSelectToAccount();
                    setExistBankName();
                    setExistBranchName();
                    setExistEmail();
                    setExistMobile();
                    setErrorMSG();
                    setSelectBankAll([]);
                    setSelectBranchAll([]); 
                }else{
                    setErrorMSG(results.message);
                }
            })
        }
         

        if(RemoveRecipient){
            return(
            <SuccessMSG ConfirmSuccess={RemoveRecipient} onHide={()=>setRemoveRecipient(false)} 
            Close={()=>setRemoveRecipient(false)} head="SUCCESSFULLY" head2="REMOVED" 
            contentline1="Successfully Removed Your Recipient"
             />
             )
        }else if(EditRecipient){
            return(
            <SuccessMSG ConfirmSuccess={EditRecipient} onHide={()=>setEditRecipient(false)} 
            Close={()=>setEditRecipient(false)} head="SUCCESSFULLY" head2="UPDATED" 
            contentline1="Successfully Updated Your Recipient"
             />)
        }else{
        return (
            <Modal
              show={props.isOpen}
              size="md"
              aria-labelledby="contained-modal-title-vcenter"
              centered 
              backdrop="static"
              onHide={props.toggle}
            >
              <Modal.Header closeButton>
                <Modal.Title  id="contained-modal-title-vcenter">
                  <p className='modal-head-f'>MAINTAIN</p><br/>TRANSFER RECIPIENT
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>                
                <Form >
                    <Form.Group as={Row} className="mb-1">
                        <Form.Label className="c-font" column sm={5}>
                           Select Recipient
                        </Form.Label>
                        <Col sm={7}>
                        <Form.Select 
                          size="sm"                         
                          className="form-h2 "
                          value={JSON.stringify(SelectFromAll)}
                          onChange={SelectRecipientList}
                          >
                              <option value={JSON.stringify("select")}>Select</option>
                              {SelectFromAccount?SelectFromAccount.map((ListValue,index)=>{
                                 return (
                                 <option  key={index} value={JSON.stringify(ListValue)}>
                                   Account Number : {ListValue.beneAccountNo} | Bank : {ListValue.beneBankName} | Name : {ListValue.beneName}
                                  </option>)
                              }):
                              null
                              }                              
                          </Form.Select>
                        </Col>
                    </Form.Group>
                    {ExistSelectToAccount?
                    <Form.Group as={Row} className="mb-1" >
                        <Form.Label className="c-font" column sm={5}>
                          Bank Name
                        </Form.Label>
                        <Form.Label className="c-font" column sm={7}>
                        {ExistBankName}
                        </Form.Label>
                    </Form.Group>
                    :null}
                     {ExistSelectToAccount?
                    <Form.Group as={Row} className="mb-1" >
                        <Form.Label className="c-font" column sm={5}>
                          Branch Name
                        </Form.Label>
                        <Form.Label className="c-font" column sm={7}>
                        {NewBankId===37?"Kandy":ExistBranchName}
                        </Form.Label>
                    </Form.Group>
                    :null}
                    <Form.Group as={Row} className="mb-1" >
                        <Form.Label className="c-font" column sm={5}>
                            Beneficiary Name
                        </Form.Label>
                        <Col sm={7} >
                         <Form.Control 
                         value={ExistBeneName}
                         onChange={(e)=>setExistBeneName(e.target.value)}
                         className="form-h2" size="sm" type="text" 
                         placeholder="Beneficiary Name" 
                         disabled={!CheckEdit}/>
                        </Col>
                    </Form.Group>
                    <Form.Group as={Row} className="mb-1" >
                        <Form.Label className="c-font" column sm={5}>
                          Beneficiary Account
                        </Form.Label>
                        <Col sm={7} >
                         <Form.Control 
                         value={ExistSelectToAccount}
                         onChange={(e)=>setExistSelectToAccount(e.target.value)}
                         className="form-h2" size="sm" type="text"
                        placeholder="Beneficiary Account"
                        disabled={!CheckEdit} />
                        </Col>
                    </Form.Group>
                    
                    {CheckEdit?
                    <Form.Group as={Row} className="mb-1">
                        <Form.Label className="c-font" column sm={5}>
                         New Bank
                        </Form.Label>
                        <Col sm={7} >
                        <Form.Select                              
                            value={JSON.stringify(SelectBankAll)}
                            onChange={SelectBankList} 
                            size="sm" className={!NewSelectBank?"form-h2 password-f":"form-h2"}>
                                <option  value={JSON.stringify("select")}>Select</option>
                            { BankList.map((listValue,index)=>{
                                return (<option value={JSON.stringify(listValue)}>{listValue.name}</option>)
                                })
                            }
                            </Form.Select>
                        </Col>
                    </Form.Group>
                    :null}
                    
                    {CheckEdit&&NewBankId!==37?
                    <Form.Group as={Row} className="mb-1">
                        <Form.Label className="c-font" column sm={5}>
                         New Branch
                        </Form.Label>
                        <Col sm={7} >
                        <Form.Select
                            value={JSON.stringify(SelectBranchAll)} 
                            onChange={SelectedBranch} size="sm" className={!NewSelectedBranch?"form-h2 password-f":"form-h2 "}>
                                <option value={JSON.stringify("select")}>Select</option>
                                { BranchList.map((listValue,index)=>{
                                return ( <option value={JSON.stringify(listValue)}>{listValue.name} - {listValue.code}</option>)
                                })                            
                                }                                    
                        </Form.Select>
                        </Col>
                    </Form.Group>
                    :null}
                    <Form.Group as={Row} className="mb-1">
                        <Form.Label className="c-font" column sm={5}>
                        Beneficiary Mobile
                        </Form.Label>
                        <Col sm={7} >
                         <Form.Control value={ExistMobile} 
                         onChange={(e)=>setExistMobile(e.target.value)}
                         className="form-h2" size="sm" type="email" placeholder="Phone Number"
                         disabled={!CheckEdit} />
                        </Col>
                    </Form.Group>
                    <Form.Group as={Row} className="mb-1">
                        <Form.Label className="c-font" column sm={5}>
                        Beneficiary Email
                        </Form.Label>
                        <Col sm={7} >
                        <Form.Control value={ExistEmail}
                        onChange={(e)=>setExistEmail(e.target.value)}
                         className="form-h2" size="sm" type="email" placeholder="Email" 
                         disabled={!CheckEdit}/>
                        </Col>
                    </Form.Group>
                    <Form.Group as={Row} className="mb-1">
                        <Form.Label className="c-font" column sm={5}>
                        Password
                        </Form.Label>
                        <Col sm={7} >
                        <Form.Control 
                            maxLength={8}
                            value={Password}
                            onChange={(text)=>setPassword(text.target.value)}
                            className={!Password?"form-h2 password-f":"form-h2"} size="sm" type="password" placeholder="Password" />
                        </Col>
                    </Form.Group>
                    <p className='vali-txt'>{ErrorMSG}</p>
                </Form>
              </Modal.Body>
              <Modal.Footer className="mb-1 margintop-f2">

                {CheckEdit?
                <Button className="btn-logout" onClick={()=>{EditCheckFirstPassword()}}>UPDATE</Button>
                :  
                <Button className="btn-logout rm-btn" onClick={()=>{RemoveCheckFirstPassword()}}>REMOVE</Button>
                }        
                <p >Edit</p>
                <Switch 
                onChange={handleEdit} 
                checked={CheckEdit} 
                onColor="#05b083"  
                className='switch'                  
                /> 
              </Modal.Footer>
            </Modal>
          );
        }
    }

export default MaintainTransferRecipient;